import ErrorModal, { ErrorModalProps } from '../../../components/error-modal/error-modal.component';
import LoadingModal, { LoadingModalProps } from '../../../components/loading-modal/loading-modal.component';
import WizardNavigationFooter, { WizardNavigationFooterProps } from '../wizard-navigation-footer/wizard-navigation-footer.component';
import WizardNavigationHeader, { WizardNavigationHeaderProps } from '../wizard-navigation-header/wizard-navigation-header.component';

const ID = 'wizard-screen-container';
export interface WizardScreenContainerProps {
    id?: string;
    header?: WizardNavigationHeaderProps;
    footer?: WizardNavigationFooterProps;
    loadingModal?: LoadingModalProps;
    errorModal?: ErrorModalProps;

    children?: React.ReactNode;
    containerClassName?: string;
    footerNotice?: React.ReactNode;
}

const WizardScreenContainer = (props: WizardScreenContainerProps) => {
    return (
        <div
            id={props.id || ID}
            className='bg-background-default flex h-dvh w-full flex-col overflow-hidden'>
            <WizardNavigationHeader {...props.header} />
            <div
                className={
                    props.containerClassName ||
                    `flex ${props.footerNotice ? 'min-h-0 flex-1 pb-12' : 'size-full'} flex-col gap-6 overflow-x-hidden overflow-y-auto p-6`
                }>
                {props.children}
            </div>
            {props.footerNotice ? (
                <div className='relative flex w-full shrink-0 flex-col self-stretch'>
                    <div className='pointer-events-none absolute right-6 bottom-full left-6 z-10 mb-2'>{props.footerNotice}</div>
                    <WizardNavigationFooter {...props.footer} />
                </div>
            ) : (
                <WizardNavigationFooter {...props.footer} />
            )}
            <LoadingModal {...props.loadingModal} />
            <ErrorModal {...props.errorModal} />
        </div>
    );
};

export default WizardScreenContainer;
